/**
 * 配置编译环境和线上环境之间的切换
 */
let baseUrl = ''
    // if (process.env.NODE_ENV === 'development') {
    //     baseUrl = 'http://192.168.10.39:8080/hsss-hospital-api'
    // } else if (process.env.NODE_ENV === 'production') {
    //     baseUrl = 'http://192.168.10.39:8080/hsss-hospital-api'
    // }
if (process.env.NODE_ENV === 'development') {
    baseUrl = 'https://agent.juzicps.com//'

    // baseUrl = 'http://192.168.31.29:9002/'
} else if (process.env.NODE_ENV === 'production') {
    baseUrl = 'https://agent.juzicps.com//'
}

export {
    baseUrl
}
